
import { defineComponent, PropType } from 'vue'

const ColorMap = {
  robin: {
    bg: 'bg-robin',
    text: 'text-robin-200',
    icon: 'current'
  },
  cherry: {
    bg: 'bg-cherry',
    text: 'text-cherry',
    icon: 'current'
  },
  honey: {
    bg: 'bg-honey',
    text: 'text-honey',
    icon: 'current'
  }
}

export default defineComponent({
  name: 'UIAlertBox',
  props: {
    color: {
      type: String as PropType<keyof typeof ColorMap>,
      default: 'robin',
      validator: (value: string) => {
        return Object.keys(ColorMap).includes(value)
      }
    },
    icon: {
      type: String,
      default: 'info'
    },
    content: {
      type: String,
      default: 'This is an alert box'
    }
  },
  computed: {
    colorClasses() {
      return ColorMap[this.color]
    }
  }
})
